'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'About';
      var url = _config2.default.domain + _config2.default.routes.about;

      var bannerImage = 'park';
      var bannerHeadline = 'About Gender Equality Funds';
      var bannerSubtitle = "We're here to help you invest your values";

      var equileapLogo = require('../../../static/images/equileap-logo.png');
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var img1 = require('../../../static/images/about-1.jpg');
      var img2 = require('../../../static/images/about-2.jpg');
      var img3 = require('../../../static/images/gef-desktop.jpg');

      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Investing in gender equality'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'You don\'t have to be a financial expert to practice gender-lens investing.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-401k-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-401k-info-title' },
                  'Sustainable and responsible investing made easy'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Gender Equality Funds is a search platform that enables you to find out if your money, in the form of individual mutual fund investments or an employer-provided 401(k), is invested in companies leading on gender diversity and equality. You can find socially responsible options that prioritize companies with an equal gender balance and strong policies promoting gender equality.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'You can help build a more equal world by investing in companies that offer women success in the workplace, without sacrificing returns. A growing body of research correlates various gender-lens investing criteria with higher financial performance and lower investment risk.'
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'x-401k-photo',
                src: img1,
                alt: 'Sustainable and responsible investing made easy'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-ays-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-ays-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-ays-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-ays-info-title' },
                  'Who we are'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For more than two decades, As You Sow has been promoting responsible investing. As part of our ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.aysinvest,
                      xstrong: true,
                      title: 'As You Sow - Invest Your Values'
                    },
                    'Invest Your Values program'
                  ),
                  ', we\'ve created a series of platforms that provide free analysis and information to help people avoid investments in fossil fuels, weapons, tobacco, and other morally questionable products and business practices.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'To build ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Gender Equality Funds'
                  ),
                  ', As You Sow partnered with ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.equileap,
                      xstrong: true,
                      title: 'Equileap'
                    },
                    'Equileap'
                  ),
                  ', a women-led social venture working to accelerate progress towards gender equality as a vital lever in reducing poverty and inequality.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'double-logo-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'double-logo' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-first-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.ays,
                        title: 'As You Sow'
                      },
                      _react2.default.createElement('img', {
                        styleName: 'logo-ays',
                        src: aysLogo,
                        alt: 'As You Sow'
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-second-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.equileap,
                        title: 'Equileap' },
                      _react2.default.createElement('img', {
                        styleName: 'logo-equileap',
                        src: equileapLogo,
                        alt: 'Equileap'
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'x-ays-photo',
                src: img2,
                alt: 'Who we are - As You Sow'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-desktop-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-desktop-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-desktop-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-info-title' },
                  'How Gender Equality Funds works'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Look up mutual funds, using up-to-date fund data from Morningstar'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'We cross-reference your investments, using Equileap\u2019s company gender equality scores'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'See how funds score on gender balance in leadership and workforce; equal compensation and work life balance; policies promoting gender equality; and commitment, transparency, and accountability'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Review the financial performance data, and compare to various benchmarks'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.howitworks,
                      xstrong: true,
                      title: 'How it works' },
                    'See how it works ',
                    _react2.default.createElement(_components.LinkIcon, null)
                  ),
                  '``'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-info-title-2' },
                  'Use our action toolkit'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Learn how to invest your values and get started with gender lens investing'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Push your employer to provide 401(k) options that rank higher on gender equality'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Find educational resources on the benefits of gender lens investing'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      xstrong: true,
                      title: 'Action toolkit' },
                    'View the action toolkit ',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'x-desktop-photo',
                src: img3,
                alt: 'How Gender Equality Funds works'
              })
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1299
// module chunks = 0